import ACTIONS from '../actions.js'

export function uiReducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_SUBMITTING:
      return { ...state, submitting: action.value }

    case ACTIONS.SET_COPY_SUCCESS:
      return { ...state, copySuccess: action.value }

    default:
      return state
  }
}

export default uiReducer
